import { render, staticRenderFns } from "./BusinessNameDataUpdateTaskLevel1.vue?vue&type=template&id=887a142c&scoped=true&"
import script from "./BusinessNameDataUpdateTaskLevel1.vue?vue&type=script&lang=js&"
export * from "./BusinessNameDataUpdateTaskLevel1.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameDataUpdateTaskLevel1.vue?vue&type=style&index=0&id=887a142c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887a142c",
  null
  
)

export default component.exports